const _excluded = ["svgRef", "title"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import React from "react";

var _ref2 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M25.39 21.486C25.7624 21.1891 25.9486 20.7829 25.9486 20.2672C25.9486 19.8948 25.8496 19.581 25.6517 19.3258C25.4538 19.068 25.0879 18.8115 24.554 18.5563C24.1504 18.3636 23.8939 18.2308 23.7845 18.1579C23.6777 18.0823 23.5996 18.0055 23.5501 17.9274C23.5007 17.8467 23.4759 17.7529 23.4759 17.6461C23.4759 17.4743 23.5371 17.3349 23.6595 17.2282C23.7819 17.1214 23.9577 17.068 24.1868 17.068C24.3796 17.068 24.5749 17.0928 24.7728 17.1422C24.9733 17.1917 25.2259 17.279 25.5306 17.404L25.9212 16.4625C25.627 16.3349 25.3444 16.236 25.0736 16.1657C24.8053 16.0954 24.5228 16.0602 24.2259 16.0602C23.6217 16.0602 23.1478 16.2047 22.804 16.4938C22.4629 16.7829 22.2923 17.18 22.2923 17.6852C22.2923 17.9534 22.3444 18.1878 22.4486 18.3883C22.5527 18.5888 22.6921 18.7646 22.8665 18.9157C23.041 19.0667 23.3027 19.2243 23.6517 19.3883C24.0241 19.5654 24.2702 19.6943 24.39 19.775C24.5124 19.8558 24.6048 19.9404 24.6673 20.029C24.7298 20.1149 24.7611 20.2138 24.7611 20.3258C24.7611 20.5263 24.6895 20.6774 24.5462 20.779C24.4056 20.8805 24.2025 20.9313 23.9369 20.9313C23.7155 20.9313 23.4707 20.8961 23.2025 20.8258C22.9368 20.7555 22.6113 20.6344 22.2259 20.4625V21.5875C22.6947 21.8167 23.2337 21.9313 23.8431 21.9313C24.5046 21.9313 25.0202 21.7829 25.39 21.486Z"
});

var _ref3 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M17.3353 21.8532H15.9525L14.6243 19.693L13.2962 21.8532H11.9993L13.8939 18.9079L12.1204 16.1422H13.4564L14.6868 18.1969L15.8939 16.1422H17.1986L15.4056 18.9743L17.3353 21.8532Z"
});

var _ref4 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M18.054 21.8532V16.1422H19.265V20.8532H21.5814V21.8532H18.054Z"
});

var _ref5 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M20.5256 3.1201L25.7259 8.61943C25.9015 8.8051 25.9993 9.05095 25.9993 9.3065V12.3332H28.3327C28.885 12.3332 29.3327 12.7809 29.3327 13.3332V24.6665C29.3327 25.2188 28.885 25.6665 28.3327 25.6665H25.9993V26.9998C25.9993 27.6187 25.7535 28.2122 25.3159 28.6498C24.8783 29.0873 24.2849 29.3332 23.666 29.3332H4.99935C4.38051 29.3332 3.78702 29.0873 3.34943 28.6498C2.91185 28.2122 2.66602 27.6187 2.66602 26.9998V4.99984C2.66602 4.381 2.91185 3.78751 3.34943 3.34992C3.78702 2.91234 4.38051 2.6665 4.99935 2.6665H19.666C19.8724 2.6665 20.0719 2.73026 20.2384 2.84653C20.3514 2.91773 20.4492 3.01093 20.5256 3.1201ZM4.76365 4.76413C4.82616 4.70162 4.91094 4.6665 4.99935 4.6665H18.706V9.3065C18.706 9.85879 19.1537 10.3065 19.706 10.3065H23.9993V12.3332H9.33268C8.7804 12.3332 8.33268 12.7809 8.33268 13.3332V24.6665C8.33268 25.2188 8.7804 25.6665 9.33268 25.6665H23.9993V26.9998C23.9993 27.0882 23.9642 27.173 23.9017 27.2355C23.8392 27.2981 23.7544 27.3332 23.666 27.3332H4.99935C4.91095 27.3332 4.82616 27.2981 4.76365 27.2355C4.70113 27.173 4.66602 27.0882 4.66602 26.9998V4.99984C4.66602 4.91143 4.70114 4.82665 4.76365 4.76413ZM22.6774 8.3065L20.706 6.22174V8.3065H22.6774ZM10.3327 14.3332V23.6665H27.3327V14.3332H10.3327Z"
});

const SvgXlsxDocument = _ref => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("title", null, title), _ref2, _ref3, _ref4, _ref5);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgXlsxDocument, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/xlsx-document.bcda27d2.svg";
export { ForwardRef as ReactComponent };